// extracted by mini-css-extract-plugin
export var container = "_mx-0";
export var dotAnimation = "_mx-2";
export var dotsLoading = "_mx-1";